import { render, staticRenderFns } from "./FormElement.vue?vue&type=template&id=23ad1a17&scoped=true"
import script from "./FormElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormElement.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FormElement.vue?vue&type=style&index=0&id=23ad1a17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad1a17",
  null
  
)

export default component.exports